'use client'
import React from 'react'

import { useGladlyChat } from '@src/hooks/useGladlyChat'
import { Button, BUTTON_TYPES } from '@src/quince-components/src'
import {
  getAddClickOnHyperRenderOption,
  TRACKING_EVENT_BY_SECTION_TYPES,
} from '@src/quince-site-integrated/src/components/ContactUs/MarketingSection'
import richTextRenderer from '@src/quince-site-integrated/src/utils/richTextRenderer'
import { trackEvent } from '@src/telemetry/track'

import { TextSection, Banner } from '../../contact-us.types'

import styles from './support.module.scss'

interface Props {
  sections: TextSection[]
  title?: TextSection
  bannerData?: Banner
  disclaimerText?: TextSection
}

const SupportSection = ({ sections = [], disclaimerText }: Props) => {
  const { openChat } = useGladlyChat()

  return (
    <div className={styles.supportWrapper}>
      <div className={styles.supportHeader}>still need help?</div>
      <div className={styles.support}>
        {sections.map((textObj, idx) => (
          <div className={styles.card} key={`support_${idx}`}>
            {richTextRenderer(
              textObj.text.json,
              TRACKING_EVENT_BY_SECTION_TYPES[textObj.sectionType]
                ? getAddClickOnHyperRenderOption(() => {
                    trackEvent(TRACKING_EVENT_BY_SECTION_TYPES[textObj.sectionType], {
                      placing: 'contact_us',
                    })
                  })
                : undefined,
            )}
            {idx === 0 && (
              <Button classNames={[styles.card__link]} type={BUTTON_TYPES.SECONDARY_LINK} onClick={openChat}>
                Chat Now
              </Button>
            )}
          </div>
        ))}
      </div>
      <p className={styles.supportDisclaimer}> {richTextRenderer(disclaimerText?.text.json)}</p>
    </div>
  )
}

export default SupportSection
